import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserSessionStore } from './shared/services/user-session.store';
import { MainModuleManagerService } from './shared/services/module-manager.service';

export const authGuard: CanActivateFn = () => {
  const sessionStore = inject(UserSessionStore);
  const router = inject(Router);
  const location = inject(Location);

  if (sessionStore.isAuthenticated()) {
    return true;
  }

  router.navigate(['/login'], { queryParams: { fromUrl: location.path() } });
  return false;
};

export const moduleGuard: CanActivateFn = (route, state) => {
  const mainModuleManagerService = inject(MainModuleManagerService);
  const sessionStore = inject(UserSessionStore);
  const router = inject(Router);
  const requiredModule = route.data['module'];
  if (requiredModule && !sessionStore.userSession()?.modules.some(m => m.name === requiredModule)) {
    const landingRoute = mainModuleManagerService.getPostLoginRoute(sessionStore.userSession()?.modules ?? []);
    router.navigate([landingRoute]);
    mainModuleManagerService.initExplainMainModule(sessionStore.userSession()?.modules ?? []);
    return false;
  }
  return true;
};
